import { useTranslation } from "react-i18next";
import {
  Container,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";

function Compare() {
  const { t } = useTranslation();

  const featureRows = [
    {
      feature: t("compare.features.mobileCapture"),
      free: true,
      pro: true,
      org: true,
    },
    {
      feature: t("compare.features.zoneMeasurement"),
      free: true,
      pro: true,
      org: true,
    },
    {
      feature: t("compare.features.shareableReports"),
      free: true,
      pro: true,
      org: true,
    },
    {
      feature: t("compare.features.cloudStorage"),
      free: false,
      pro: true,
      org: true,
    },
    {
      feature: t("compare.features.webPortal"),
      free: false,
      pro: true,
      org: true,
    },
    {
      feature: t("compare.features.customLists"),
      free: false,
      pro: true,
      org: true,
    },
    {
      feature: t("compare.features.dataExport"),
      free: false,
      pro: true,
      org: true,
    },
    {
      feature: t("compare.features.multiUser"),
      free: false,
      pro: false,
      org: true,
    },
    {
      feature: t("compare.features.centralBilling"),
      free: false,
      pro: false,
      org: true,
    },
    {
      feature: t("compare.features.advancedReporting"),
      free: false,
      pro: false,
      org: true,
    },
  ];
  return (
    <>
      <Container maxWidth="lg">
        <Typography variant="h4" component="h1" align="center" gutterBottom>
          {t("compare.title")}
        </Typography>
        <Typography
          variant="h6"
          align="center"
          color="text.secondary"
          paragraph
        >
          {t("compare.subtitle")}
        </Typography>

        <TableContainer component={Paper} sx={{ my: 4 }}>
          <Table aria-label="compare versions table">
            <TableHead>
              <TableRow
                sx={{
                  "& .MuiTableCell-head": {
                    backgroundColor: "primary.main",
                    color: "common.white",
                    fontSize: "1.1rem",
                  },
                }}
              >
                <TableCell>{t("compare.feature")}</TableCell>
                <TableCell align="center">{t("compare.planFree")}</TableCell>
                <TableCell align="center">{t("compare.planPro")}</TableCell>
                <TableCell align="center">{t("compare.planOrg")}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {featureRows.map((row) => (
                <TableRow
                  key={row.feature}
                  sx={{
                    "&:nth-of-type(odd)": {
                      backgroundColor: (theme) => theme.palette.action.hover,
                    },
                  }}
                >
                  <TableCell component="th" scope="row">
                    {row.feature}
                  </TableCell>
                  <TableCell align="center">
                    {row.free ? (
                      <CheckIcon color="success" />
                    ) : (
                      <CloseIcon color="error" />
                    )}
                  </TableCell>
                  <TableCell align="center">
                    {row.pro ? (
                      <CheckIcon color="success" />
                    ) : (
                      <CloseIcon color="error" />
                    )}
                  </TableCell>
                  <TableCell align="center">
                    {row.org ? (
                      <CheckIcon color="success" />
                    ) : (
                      <CloseIcon color="error" />
                    )}
                  </TableCell>
                </TableRow>
              ))}
              {/* Placeholder for Pricing Row */}
              <TableRow>
                <TableCell
                  component="th"
                  scope="row"
                  sx={{ fontWeight: "bold" }}
                >
                  {t("compare.price")}
                </TableCell>
                <TableCell align="center" sx={{ fontWeight: "bold" }}>
                  {t("compare.priceFree")}
                </TableCell>
                <TableCell align="center" sx={{ fontWeight: "bold" }}>
                  {t("compare.pricePro")}
                </TableCell>
                <TableCell align="center" sx={{ fontWeight: "bold" }}>
                  {t("compare.priceOrg")}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
        <Typography
          variant="body2"
          align="center"
          color="text.secondary"
          sx={{ fontStyle: "italic", mb: 4 }}
        >
          {t("compare.betaPricingNote")}
        </Typography>
      </Container>
    </>
  );
}

export default Compare;
